import { FC, useState, useEffect } from 'react';
import { CustomEditor, ImageUpload, Input } from '../../../../commons';
import PostBlocks from './PostBlocks';

interface NewPostFormProps {
  values: any;
  setFieldValue: any;
  edit?: boolean;
}
const PostForm: FC<NewPostFormProps> = ({ values, setFieldValue, edit }) => {
  const [initialValue, setInitialValue] = useState(values.postContent);

  const handleImageChange = (e: any) => {
    const file = e.target.files[0];
    setFieldValue('imageFile', file);

    const image = URL.createObjectURL(file);
    setFieldValue('imageCover', image);
  };

  useEffect(() => {
    setFieldValue('postContent', initialValue);
  }, [initialValue]);

  return (
    <div className='flex flex-col gap-6 w-full mt-4'>
      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 items-start'>
        <div className='col-span-1 md:col-span-2'>
          <Input type='text' name='title' label='Post Title' />
        </div>
        <div className='col-span-1 border border-gray-200 dark:border-gray-700 rounded-xl p-4'>
          <label className='block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2'>Post Cover Image</label>
          <ImageUpload tourImage={values.imageCover} tourImageHandler={handleImageChange} />
        </div>
      </div>
      
      <div className='flex flex-col space-y-1.5'>
        <label className='block text-sm font-medium text-gray-700 dark:text-gray-200'>Post Content</label>
        <CustomEditor
          placeholder='Type description here...'
          onChange={setInitialValue}
          value={initialValue}
          name='postContent'
        />
      </div>

      <PostBlocks setFieldValue={setFieldValue} values={values} edit={edit} />
    </div>
  );
};

export default PostForm;
